/* The app's entry point. esbuild bundles it, and everything it imports, into assets/js/app.js.
   Modules run in the order they're listed here. A module only imports from modules above it, so that
   order holds; code that needs something further down calls it through App (e.g. App.selChanged()). */
import './core/events';
import { S, el } from './core/base';
import './core/helpers';
import './core/haptics';
import './core/api';
import './core/worklens';
import './core/feed';
import './core/lists';
import './core/dom';
import './core/auth';
import { parseHash, refreshAll } from './core/router';
import './features/refunds';
import './features/started';
import './features/txform';
import './features/bulk';
import './features/attachments';
import './features/charts';
import './features/networth';
import './features/subs';
import './features/pace';
import './features/grid';
import './features/flow';
import './features/chartfit';
import './features/tilepreview';
import './features/magnet';
import './features/edge';
import './features/dashboard';
import './features/pageopts';
import './pages/loans';
import './pages/bills';
import './pages/budgets';
import './pages/piggy';
import './features/phone';
import './features/fabdodge';
import './features/pinhead';
import './pages/overview';
import './pages/transactions';
import './pages/accounts';
import './pages/categories';
import './core/login';
import './pages/reconcile';
import './pages/rules';
import './pages/recurring';
import './pages/reports';
import './pages/recap';
import './pages/year';
import './pages/timeline';
import './pages/map';
import './pages/settings';
import './pages/cleanup';
import './features/palette';
import './features/polish';
import './features/dock';
import './features/datepicker';
import './pages/forecast';
import './pages/ask';
import './pages/inbox';
import './pages/review';
import './features/pwa';
import './features/ffstatus';
import './features/insights';
import './features/prefs';
import './features/sync';
import './features/gestures';
import './features/picker';
import './features/keyboard';
import './features/nldate';
import './features/nlparse';
import './features/shell';
import './features/whatsnew';

// For the smoke test (dev/smoke_test.py) and the browser console
Object.assign(window, { S, el, parseHash, refreshAll });
